import type { ReactNode } from "react";

interface PageLayoutProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

export default function PageLayout({
  title,
  subtitle,
  actions,
  children,
  footer,
}: PageLayoutProps) {
  return (
    <div className="flex flex-col min-h-full">
      {/* Header */}
      <header className="sticky top-0 z-10 bg-bg-primary px-4 py-4 sm:px-6 sm:py-5 lg:px-8 lg:py-6 border-b border-border-secondary print:!hidden">
        <div className="mx-auto max-w-7xl">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h1 className="text-lg font-semibold text-text-primary sm:text-display-xs">
                {title}
              </h1>
              {subtitle && (
                <p className="mt-0.5 text-sm text-text-secondary sm:mt-1 sm:text-md">
                  {subtitle}
                </p>
              )}
            </div>
            {actions && <div className="flex items-center gap-3">{actions}</div>}
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="flex-1 px-4 py-4 sm:px-6 sm:py-5 lg:px-8 lg:py-6">
        <div className="mx-auto max-w-7xl">{children}</div>
      </div>

      {/* Footer */}
      {footer && (
        <footer className="border-t border-border-secondary bg-bg-primary px-4 py-3 sm:px-6 sm:py-4 lg:px-8">
          <div className="mx-auto max-w-7xl">{footer}</div>
        </footer>
      )}
    </div>
  );
}
